import React, { useEffect, useState } from "react";
import { InlineNotification } from "carbon-components-react";

import {
  ActionableEvent,
  ActionableEvents,
  getEventMessage,
} from "@eave/shared/types/api/actionable-events";

import APIClient from "../../../APIClient";
import Spinner from "../../../shared/Spinner";

const ackActionableEvent = (id: number): Promise<any> => {
  return APIClient.patch(`/uw/actionable_event/${id}`, {
    send_ack_to_homelight: false,
  });
};

const Notification = ({ appId }) => {
  const [loading, setLoading] = useState<boolean>(true); // spinner for whole-page loads/reloads

  const [actionableEvents, setActionableEvents] = useState<ActionableEvent[] | null>(null);

  const loadActionableEvents = () =>
    APIClient.get(`/uw/loan_applications/${appId}/actionable_event`).then((result: any) => {
      const events = result.actionable_events.filter(event => {
        return [
          ActionableEvents.LoanDownpaymentChangeEvent,
          ActionableEvents.RateLockChangeEvent,
        ].includes(event.name);
      });

      events.forEach(event => {
        event.message = getEventMessage(event.name);
      });

      setActionableEvents(events);
    });
  useEffect(() => {
    setLoading(true);
    loadActionableEvents().finally(() => {
      setLoading(false);
    });
  }, [appId]);

  if (loading) {
    return <Spinner active />;
  }

  return (
    <>
      {actionableEvents.map(e => {
        return (
          <InlineNotification
            key={e.id}
            title="WARNING"
            subtitle={e.message}
            role="alert"
            kind="warning"
            notificationType="inline"
            statusIconDescription="Warning"
            onCloseButtonClick={() => {
              ackActionableEvent(e.id);
            }}
          />
        );
      })}
    </>
  );
};

export default Notification;
